
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[langCountry]/[slug]/[productSlug]",
      function () {
        return require("private-next-pages/[langCountry]/[slug]/[productSlug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[langCountry]/[slug]/[productSlug]"])
      });
    }
  